"use client";

import { useToast } from "app/hooks";
import { FreeTicketIcon } from "./Icons";
import { MissionListItem } from "./MissionListItem";
import clsx from "clsx";

export function Toast() {
  const { toastData } = useToast();

  return (
    <div className={"toast" + (toastData && toastData.length ? " mode-active" : "")}>
      {toastData &&
        toastData.map((data) => {
          return (
            <div
              key={data.toastIndex}
              className={
                "toast-item" +
                (data.died ? " mode-died" : "") +
                (data.type ? " mode-" + data.type : "")
              }
            >
              <span className={clsx("toast-item-label", data.isStripeError && "mode-stripe-error")}>
                {data.message}
              </span>
              {data.type === "bonus" && data.bonusValue && (
                <>
                  <span className="toast-item-bonus">
                    <FreeTicketIcon size={24} className="toast-item-bonus-icon" />
                    すぐ無料チケットを{data.bonusValue}枚獲得しました
                  </span>
                </>
              )}
              {data.type === "mission" && data.missionContent && (
                <MissionListItem
                  mission={{ ...data.missionContent, linkDestination: undefined }}
                  isToast={true}
                />
              )}
            </div>
          );
        })}
    </div>
  );
}
